<template>
  <div class="videos-widget">
    <Toolbar class="videos-widget__toolbar" title-tag="h2">
      <template #title>
        Видео
      </template>
    </Toolbar>

    <div class="videos-widget__wrap">
      <VideosWidgetItem
        v-for="(item, index) of videos"
        :key="index"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar";
import VideosWidgetItem from "./VideosWidgetItem";
import { mapState, mapMutations } from "vuex";
import service from "@/services/site";

export default {
  name: "VideosWidget",

  components: {
    Toolbar,
    VideosWidgetItem
  },

  computed: {
    ...mapState("dictionaries", {
      videos: ({ dictionaries }) => dictionaries.videos || new Array(2)
    })
  },

  created() {
    if (!this.videos[0]) this.loadVideos();
  },

  methods: {
    ...mapMutations("dictionaries", ["SET_DICTIONARY"]),
    async loadVideos() {
      this.SET_DICTIONARY({
        dictionaryName: "videos",
        dictionary: await service.getVideos()
      });
    }
  }
};
</script>

<style lang="scss">
.videos-widget {
  &__toolbar {
    margin-bottom: 20px;
  }
}
</style>
